import {match, Pattern} from 'ts-pattern';

import {VehicleCategoryFilter} from '../pages/AllOffers/types/VehicleCategoryFilter';

const CAR_BODY_STYLE_PREFIX = 'CARSTYLE_';
const VAN_BODY_STYLE_PREFIX = 'VANSTYLE_';

/**
 * Resolves the vehicle category of a `car_style` enum key by its prefix.
 * `CARSTYLE_VAN` (Caddy, Berlingo) is a passenger car body, `VANSTYLE_VAN` (Transporter, Sprinter) is a van body.
 * Returns `null` for keys that belong to neither category.
 */
export function getBodyStyleCategory(bodyStyleKey: string): VehicleCategoryFilter | null {
  return match(bodyStyleKey)
    .with(Pattern.string.startsWith(CAR_BODY_STYLE_PREFIX), () => VehicleCategoryFilter.CAR)
    .with(Pattern.string.startsWith(VAN_BODY_STYLE_PREFIX), () => VehicleCategoryFilter.VAN)
    .otherwise(() => null);
}
